export const HIDE_WISEPOPS_CLASSNAME = '--hide-wisepops';
export const COOKIE_SECTION_ID = 'cookie-section';
